import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const CheckInIconButton = ({ plusIconDisabled, openCheckInForm, playerId }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            {plusIconDisabled ? (
                <Tooltip title="All goals need to be Active">
                    <Box >
                        <IconButton disabled onClick={() => openCheckInForm(playerId)}>
                            <AddCircleOutlineIcon sx={{ cursor: 'pointer' }} />
                        </IconButton>
                    </Box>
                </Tooltip>
            ) : (
                <Tooltip title="Add Check-In">
                    <IconButton onClick={() => openCheckInForm(playerId)}>
                        <AddCircleOutlineIcon sx={{ cursor: 'pointer' }} />
                    </IconButton>
                </Tooltip>
            )}

        </Box>
    );
};

export default CheckInIconButton;